import * as deMessagesCommon from './de/i18nCommon.json';
import * as deMessagesLandingPage from './de/i18nLandingPage.json';
import * as enMessagesLandingPage from './en/i18nLandingPage.json';
import * as enMessagesCommon from './en/i18nCommon.json';
import * as deMessagesTermsOfUse from './de/i18nTermsOfUse.json';
import * as enMessagesTermsOfUse from './en/i18nTermsOfUse.json';
import * as deMessagesCompanyRegistration from './de/i18nCompanyRegistration.json';
import * as enMessagesCompanyRegistration from './en/i18nCompanyRegistration.json';
import * as deMessagesAdmin from './de/i18nAdmin.json';
import * as enMessagesAdmin from './en/i18nAdmin.json';
import * as deMessagesNotFound from './de/i18nNotFound.json';
import * as enMessagesNotFound from './en/i18nNotFound.json';
import * as deMessagesCookieBar from './de/i18nCookieBar.json';
import * as enMessagesCookieBar from './en/i18nCookieBar.json';
import * as deMessagesFooterModal from './de/i18nFooterModal.json';
import * as enMessagesFooterModal from './en/i18nFooterModal.json';
import * as deMessagesMasterDataSheets from './de/i18nMasterDataSheets.json';
import * as enMessagesMasterDataSheets from './en/i18nMasterDataSheets.json';
import * as deMessagesMasterDataProcessTypes from './de/i18nMasterDataProcessTypes.json';
import * as enMessagesMasterDataProcessTypes from './en/i18nMasterDataProcessTypes.json';
import * as deMessagesMasterDataCosts from './de/i18nMasterDataCosts.json';
import * as enMessagesMasterDataCosts from './en/i18nMasterDataCosts.json';
import * as deMessagesMasterDataProductTypes from './de/i18nMasterDataProductTypes.json';
import * as enMessagesMasterDataProductTypes from './en/i18nMasterDataProductTypes.json';
import * as deMessagesMasterDataOperatingFluidTypes from './de/i18nMasterDataOperatingFluidTypes.json';
import * as enMessagesMasterDataOperatingFluidTypes from './en/i18nMasterDataOperatingFluidTypes.json';
import * as deMessagesMasterDataQualityLines from './de/i18nMasterDataQualityLines.json';
import * as enMessagesMasterDataQualityLines from './en/i18nMasterDataQualityLines.json';
import * as deMessagesMasterDataSalesAreas from './de/i18nMasterDataSalesAreas.json';
import * as enMessagesMasterDataSalesAreas from './en/i18nMasterDataSalesAreas.json';
import * as deMessagesUserNotifications from './de/i18nUserNotification.json';
import * as enMessagesUserNotifications from './en/i18nUserNotification.json';
import * as deMessagesMasterDataSaeClasses from './de/i18nMasterDataSaeClasses.json';
import * as enMessagesMasterDataSaeClasses from './en/i18nMasterDataSaeClasses.json';
import * as deMessagesMasterDataMbSpecifications from './de/i18nMasterDataMbSpecifications.json';
import * as enMessagesMasterDataMbSpecifications from './en/i18nMasterDataMbSpecifications.json';
import * as enMessagesContactPage from './en/i18nContactPage.json';
import * as deMessagesContactPage from './de/i18nContactPage.json';
import * as enMessagesDashboardMyCompany from './en/i18nDashboardMyCompany.json';
import * as deMessagesDashboardMyCompany from './de/i18nDashboardMyCompany.json';
import * as enMessageExternalApplications from './en/i18nExternalApplication.json';
import * as deMessageExternalApplications from './de/i18nExternalApplication.json';
import * as deMessagesMasterDataBaseOils from './de/i18nMasterDataBaseOils.json';
import * as enMessagesMasterDataBaseOils from './en/i18nMasterDataBaseOils.json';
import * as deMessagesMasterDataAdditives from './de/i18nMasterDataAdditives.json';
import * as enMessagesMasterDataAdditives from './en/i18nMasterDataAdditives.json';
import * as deMessagesTasksSectionTranslations from './de/i18nTasksSection.json';
import * as enMessagesTasksSectionTranslations from './en/i18nTasksSection.json';
import * as deMessagesNewsSection from './de/i18nNewsSection.json';
import * as enMessagesNewsSection from './en/i18nNewsSection.json';
import * as deMessagesManagementNews from './de/i18nManagementNews.json';
import * as enMessagesManagementNews from './en/i18nManagementNews.json';
import * as deMessagesProduct from './de/i18nProduct.json';
import * as enMessagesProduct from './en/i18nProduct.json';
import * as deMessagesTestAggregatesOilTestingEngineTests from './de/i18nTestAggregatesOilTestingEngineTests.json';
import * as enMessagesTestAggregatesOilTestingEngineTests from './en/i18nTestAggregatesOilTestingEngineTests.json';
import * as deMessagesMasterDataManageTests from './de/i18nMasterDataManageTests.json';
import * as enMessagesMasterDataManageTests from './en/i18nMasterDataManageTests.json';
import * as deMessagesOilTestEngineMasterData from './de/i18nOilTestEngineMasterData.json';
import * as enMessagesOilTestEngineMasterData from './en/i18nOilTestEngineMasterData.json';
import * as deMessagesManagementServiceArea from './de/i18nManagementServiceArea.json';
import * as enMessagesManagementServiceArea from './en/i18nManagementServiceArea.json';
import * as deMessagesMasterDataContainerSize from './de/i18nMasterDataContainerSize.json';
import * as enMessagesMasterDataContainerSize from './en/i18nMasterDataContainerSize.json';
import * as deMessagesInvoices from './de/i18nInvoices.json';
import * as enMessagesInvoices from './en/i18nInvoices.json';

/**
 * A single object containing all translation texts.
 * This is required by the TranslationProvider to pass
 * these texts to the 'intl' library.
 */
export const Translations = {
    de: {
        ...deMessagesCommon,
        ...deMessagesLandingPage,
        ...deMessagesTermsOfUse,
        ...deMessagesCompanyRegistration,
        ...deMessagesAdmin,
        ...deMessagesNotFound,
        ...deMessagesCookieBar,
        ...deMessagesFooterModal,
        ...deMessagesMasterDataSheets,
        ...deMessagesMasterDataProcessTypes,
        ...deMessagesMasterDataCosts,
        ...deMessagesMasterDataProductTypes,
        ...deMessagesMasterDataOperatingFluidTypes,
        ...deMessagesUserNotifications,
        ...deMessagesMasterDataSaeClasses,
        ...deMessagesMasterDataMbSpecifications,
        ...deMessagesMasterDataQualityLines,
        ...deMessagesMasterDataSalesAreas,
        ...deMessagesContactPage,
        ...deMessagesDashboardMyCompany,
        ...deMessageExternalApplications,
        ...deMessagesMasterDataBaseOils,
        ...deMessagesMasterDataAdditives,
        ...deMessagesTasksSectionTranslations,
        ...deMessagesNewsSection,
        ...deMessagesManagementNews,
        ...deMessagesProduct,
        ...deMessagesTestAggregatesOilTestingEngineTests,
        ...deMessagesMasterDataManageTests,
        ...deMessagesOilTestEngineMasterData,
        ...deMessagesManagementServiceArea,
        ...deMessagesMasterDataContainerSize,
        ...deMessagesInvoices,
    },
    en: {
        ...enMessagesCommon,
        ...enMessagesLandingPage,
        ...enMessagesTermsOfUse,
        ...enMessagesCompanyRegistration,
        ...enMessagesAdmin,
        ...enMessagesNotFound,
        ...enMessagesCookieBar,
        ...enMessagesFooterModal,
        ...enMessagesMasterDataSheets,
        ...enMessagesMasterDataProcessTypes,
        ...enMessagesMasterDataCosts,
        ...enMessagesMasterDataProductTypes,
        ...enMessagesMasterDataOperatingFluidTypes,
        ...enMessagesUserNotifications,
        ...enMessagesMasterDataSaeClasses,
        ...enMessagesMasterDataMbSpecifications,
        ...enMessagesMasterDataQualityLines,
        ...enMessagesMasterDataSalesAreas,
        ...enMessagesContactPage,
        ...enMessagesDashboardMyCompany,
        ...enMessageExternalApplications,
        ...enMessagesMasterDataBaseOils,
        ...enMessagesMasterDataAdditives,
        ...enMessagesTasksSectionTranslations,
        ...enMessagesNewsSection,
        ...enMessagesManagementNews,
        ...enMessagesProduct,
        ...enMessagesTestAggregatesOilTestingEngineTests,
        ...enMessagesMasterDataManageTests,
        ...enMessagesOilTestEngineMasterData,
        ...enMessagesManagementServiceArea,
        ...enMessagesMasterDataContainerSize,
        ...enMessagesInvoices,
    },
};
